import { inject } from '@angular/core';
import { ResolveFn, UrlSegment } from '@angular/router';
import { ConfigService } from '@app/config.service';
import { IdentityClientService } from '@app/identity/identity-client.service';
import { IdentityConstants } from '@app/identity/identity-constants.service';

import { EventService } from '@common/event.service';
import { IdentityConfigurationService } from '@identity/identity-configuration.service';

const RELOAD_MENU_EVENT = 'reload-menu';

export const moduleResolver: ResolveFn<void> = async (route, state) => {
    const identityConfigService = inject(IdentityConfigurationService);
    const eventService = inject(EventService);
    const configService = inject(ConfigService);

    const moduleCode = getModuleCode(route.url);
    identityConfigService.setService(moduleCode);

    // Reload the menu to get the menu options with the correct module header
    eventService.emitEvent(RELOAD_MENU_EVENT, {})

    const client = new IdentityClientService(new IdentityConstants()).get();
    const clientUrl = client.url;

    await configService.getModuleConfig(clientUrl);
};

function getModuleCode(segments: UrlSegment[]): string {
    switch (segments[0].path.toLowerCase()) {
        case 'tpo':
            return 'TP';
        default:
            return 'HUB';
    }
}
